<template>

  <div class="matter-tags">

    <div class="tags-label">
      {{$t('client.matters.matter_page.tags')}}:
    </div>

    <div v-if="tags.length"
         class="tag-chips"
         ref="tag-chips">
      <v-chip v-for="(tag, i) in tags"
              :key="i"
              :ref="tag"
              class="matter-tag"
              small
              outlined>
        {{tag}}
      </v-chip>

      <v-chip class="plus-chip"
              ref="plus-chip"
              small
              outlined>
        <v-tooltip top
                   content-class="tags-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <span class="tags-plus"
                  v-bind="attrs"
                  v-on="on">
              +{{hiddenTags.length}}
            </span>
          </template>
          <span>
            {{hiddenTagsString}}
          </span>
        </v-tooltip>
      </v-chip>

    </div>

    <div v-else
         class="add-tags"
         @click="addTags">
      {{$t('client.matters.matter_page.add_tags')}}
    </div>
  </div>

</template>

<script>
  export default {
    name: "MatterTags",
    props: {
      tags: {
        type: Array
      }
    },
    data() {
      return {
        hiddenTags: []
      }
    },
    mounted() {
      this.processTags();
    },
    watch: {
      tags() {
        this.processTags();
      }
    },
    computed: {
      hiddenTagsString() {
        return this.hiddenTags.join(', ');
      }
    },
    methods: {
      processTags() {
        if (!this.tags || !this.tags.length) return;

        let that = this;

        setTimeout(() => {
          that.hiddenTags = [];
          let parentTop = that.$refs['tag-chips'].offsetTop;
          let parentHeight = that.$refs['tag-chips'].offsetHeight;
          let plusEl = that.$refs['plus-chip'].$el;
          let lastVisibleTag = null;

          Object.keys(that.$refs).forEach((key) => {
            if (key !== 'tag-chips' && key !== 'plus-chip') {
              let tagEl = that.$refs[key][0] && that.$refs[key][0].$el;
              if (tagEl) {
                if (!tagEl.offsetTop || tagEl.offsetTop >= parentTop + parentHeight) { // hiding overflowed tags and showing them in the tooltip
                  tagEl.style.display = 'none';
                  that.hiddenTags.push(key);
                } else {
                  lastVisibleTag = key;
                }
              }
            }
          });

          if (that.hiddenTags.length) {
            plusEl.style.display = 'inline-flex';

            if (!plusEl.offsetTop || plusEl.offsetTop >= parentTop + parentHeight) { // if the hidden tags counter is overflowed, hide the last visible tag and show it in the tooltip
              that.hiddenTags.unshift(lastVisibleTag);
              that.$refs[lastVisibleTag][0].$el.style.display = 'none';
            }
          } else {
            plusEl.style.display = 'none';
          }
        });
      },
      addTags() {
        if (this.$hasFeature('tags_feature')) {
          this.$emit('edit-fields');
        } else {
          this.$frontageApi.send('matter_action', {action: 'upgrade_tags'});
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .matter-tags {
    display: flex;
    padding-top: 2px;
    margin-bottom: -5px;

    .tags-label {
      color: $grey-color-6;
      @include i-padding-mirror(0, 12px);
    }

    .tag-chips {
      max-height: 60px;
      overflow: hidden;

      .matter-tag {
        height: 22px;
        @include i-margin(0, 8px, 8px, 0);
        color: $navy-color-2;
      }

      .plus-chip {
        height: 22px;
        @include i-margin(0, 8px, 8px, 0);
        color: $color_dark_text;
        border: none;
        padding: 0 5px;
      }
    }

    .add-tags {
      margin-bottom: 10px;
      color: $blue-color-3;
      cursor: pointer;
    }
  }

  .tags-tooltip {
    font-family: var(--primary-font-family);
    font-size: 12px;
    line-height: 18px;
    max-width: 305px;
    text-align: center;
  }
</style>
